import { parseClientEnv } from "@ondo/env/client";
import { createClient } from "@supabase/supabase-js";
/**
 * Builds the browser Supabase client, authenticated with the publishable key.
 *
 * Every request it makes is subject to Row Level Security, so this client is
 * safe to ship to users. Sessions persist in localStorage and refresh
 * automatically.
 *
 * Takes the env record explicitly rather than reading `import.meta.env`, so
 * this package stays bundler-agnostic and testable. The app passes
 * `import.meta.env`, which Vite populates from the root .env allowlist.
 */
export function createBrowserClient(source) {
    const env = parseClientEnv(source);
    return createClient(env.SUPABASE_URL, env.SUPABASE_PUBLISHABLE_KEY, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
        },
    });
}
//# sourceMappingURL=browser.js.map